import { j as l } from "./jsx-runtime.DGlMoOmv.js";
import * as we from "react";
import { useState as E, useEffect as V, createContext as W, useContext as F, useLayoutEffect as $e, forwardRef as Je, useRef as Qe } from "react";
import { t as N, c as oe, b as Y, d as ge, e as et, g as tt, s as _e, h as nt, j as S, f as L, k as at, l as le, n as rt, o as ot, i as je } from "./format._HymmFPq.js";
import { a as M, i as k, s as Q, b as ie } from "./subDays.KNyakmpi.js";
import { s as ee } from "./setMonth.DkCYdG2x.js";
import { b as xe } from "./button-variants.DWX6pG3S.js";
import { F as it } from "./ChevronLeft20.CgL7KAAg.js";
import { F as st } from "./ChevronRight20.XQ503sZW.js";
import { c as T } from "./index.CxSWpsOB.js";
import { getCalendarLocale as lt } from "../lib/utils/calendar-utils/index.js";
import { createPortal as dt } from "react-dom";
import { S as ut } from "./Spinner.Brgz0Lk4.js";
function j(e, n) {
  const t = N(e);
  if (isNaN(n)) return oe(e, NaN);
  if (!n)
    return t;
  const a = t.getDate(), r = oe(e, t.getTime());
  r.setMonth(t.getMonth() + n + 1, 0);
  const o = r.getDate();
  return a >= o ? r : (t.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    a
  ), t);
}
function se(e, n) {
  const t = n * 7;
  return M(e, t);
}
function ct(e, n) {
  return j(e, n * 12);
}
function ft(e) {
  let n;
  return e.forEach(function(t) {
    const a = N(t);
    (n === void 0 || n < a || isNaN(Number(a))) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function vt(e) {
  let n;
  return e.forEach((t) => {
    const a = N(t);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function B(e, n) {
  const t = N(e), a = N(n), r = t.getFullYear() - a.getFullYear(), o = t.getMonth() - a.getMonth();
  return r * 12 + o;
}
function mt(e, n, t) {
  const a = Y(e, t), r = Y(n, t), o = +a - ge(a), i = +r - ge(r);
  return Math.round((o - i) / et);
}
function de(e) {
  const n = N(e), t = n.getMonth();
  return n.setFullYear(n.getFullYear(), t + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function C(e) {
  const n = N(e);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function ue(e, n) {
  const t = tt(), a = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, r = N(e), o = r.getDay(), i = (o < a ? -7 : 0) + 6 - (o - a);
  return r.setDate(r.getDate() + i), r.setHours(23, 59, 59, 999), r;
}
function Oe(e) {
  return ue(e, { weekStartsOn: 1 });
}
function ht(e) {
  return Math.trunc(+N(e) / 1e3);
}
function yt(e) {
  const n = N(e), t = n.getMonth();
  return n.setFullYear(n.getFullYear(), t + 1, 0), n.setHours(0, 0, 0, 0), n;
}
function bt(e, n) {
  return mt(
    yt(e),
    C(e),
    n
  ) + 1;
}
function Pe(e, n) {
  const t = N(e), a = N(n);
  return +t < +a;
}
function ce(e, n) {
  const t = N(e), a = N(n);
  return t.getFullYear() === a.getFullYear() && t.getMonth() === a.getMonth();
}
function pt(e, n) {
  const t = N(e), a = N(n);
  return t.getFullYear() === a.getFullYear();
}
function De(e, n) {
  const t = N(e);
  return isNaN(+t) ? oe(e, NaN) : (t.setFullYear(n), t);
}
var y = function() {
  return y = Object.assign || function(n) {
    for (var t, a = 1, r = arguments.length; a < r; a++) {
      t = arguments[a];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, y.apply(this, arguments);
};
function wt(e, n) {
  var t = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && n.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
      n.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (t[a[r]] = e[a[r]]);
  return t;
}
function Se(e, n, t) {
  for (var a = 0, r = n.length, o; a < r; a++)
    (o || !(a in n)) && (o || (o = Array.prototype.slice.call(n, 0, a)), o[a] = n[a]);
  return e.concat(o || Array.prototype.slice.call(n));
}
function A(e) {
  return e.mode === "multiple";
}
function H(e) {
  return e.mode === "range";
}
function Z(e) {
  return e.mode === "single";
}
var gt = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function _t(e, n) {
  return L(e, "LLLL y", n);
}
function xt(e, n) {
  return L(e, "d", n);
}
function Dt(e, n) {
  return L(e, "LLLL", n);
}
function Nt(e) {
  return "".concat(e);
}
function Mt(e, n) {
  return L(e, "cccccc", n);
}
function kt(e, n) {
  return L(e, "yyyy", n);
}
var Ct = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: _t,
  formatDay: xt,
  formatMonthCaption: Dt,
  formatWeekNumber: Nt,
  formatWeekdayName: Mt,
  formatYearCaption: kt
}), jt = function(e, n, t) {
  return L(e, "do MMMM (EEEE)", t);
}, Ot = function() {
  return "Month: ";
}, Pt = function() {
  return "Go to next month";
}, St = function() {
  return "Go to previous month";
}, Wt = function(e, n) {
  return L(e, "cccc", n);
}, Ft = function(e) {
  return "Week n. ".concat(e);
}, Lt = function() {
  return "Year: ";
}, It = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: jt,
  labelMonthDropdown: Ot,
  labelNext: Pt,
  labelPrevious: St,
  labelWeekNumber: Ft,
  labelWeekday: Wt,
  labelYearDropdown: Lt
});
function Rt() {
  var e = "buttons", n = gt, t = nt, a = {}, r = {}, o = 1, i = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: n,
    formatters: Ct,
    labels: It,
    locale: t,
    modifiersClassNames: a,
    modifiers: r,
    numberOfMonths: o,
    styles: i,
    today: s,
    mode: "default"
  };
}
function Tt(e) {
  var n = e.fromYear, t = e.toYear, a = e.fromMonth, r = e.toMonth, o = e.fromDate, i = e.toDate;
  return a ? o = C(a) : n && (o = new Date(n, 0, 1)), r ? i = de(r) : t && (i = new Date(t, 11, 31)), {
    fromDate: o ? _e(o) : void 0,
    toDate: i ? _e(i) : void 0
  };
}
var We = W(void 0);
function Et(e) {
  var n, t = e.initialProps, a = Rt(), r = Tt(t), o = r.fromDate, i = r.toDate, s = (n = t.captionLayout) !== null && n !== void 0 ? n : a.captionLayout;
  s !== "buttons" && (!o || !i) && (s = "buttons");
  var d;
  (Z(t) || A(t) || H(t)) && (d = t.onSelect);
  var c = y(y(y({}, a), t), { captionLayout: s, classNames: y(y({}, a.classNames), t.classNames), components: y({}, t.components), formatters: y(y({}, a.formatters), t.formatters), fromDate: o, labels: y(y({}, a.labels), t.labels), mode: t.mode || a.mode, modifiers: y(y({}, a.modifiers), t.modifiers), modifiersClassNames: y(y({}, a.modifiersClassNames), t.modifiersClassNames), onSelect: d, styles: y(y({}, a.styles), t.styles), toDate: i });
  return l.jsx(We.Provider, { value: c, children: e.children });
}
function _() {
  var e = F(We);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function Fe(e) {
  var n = _(), t = n.locale, a = n.classNames, r = n.styles, o = n.formatters.formatCaption;
  return l.jsx("div", { className: a.caption_label, style: r.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: o(e.displayMonth, { locale: t }) });
}
function Yt(e) {
  return l.jsx("svg", y({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: l.jsx("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Le(e) {
  var n, t, a = e.onChange, r = e.value, o = e.children, i = e.caption, s = e.className, d = e.style, c = _(), u = (t = (n = c.components) === null || n === void 0 ? void 0 : n.IconDropdown) !== null && t !== void 0 ? t : Yt;
  return l.jsxs("div", { className: s, style: d, children: [l.jsx("span", { className: c.classNames.vhidden, children: e["aria-label"] }), l.jsx("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: r, onChange: a, children: o }), l.jsxs("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [i, l.jsx(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function Bt(e) {
  var n, t = _(), a = t.fromDate, r = t.toDate, o = t.styles, i = t.locale, s = t.formatters.formatMonthCaption, d = t.classNames, c = t.components, u = t.labels.labelMonthDropdown;
  if (!a)
    return l.jsx(l.Fragment, {});
  if (!r)
    return l.jsx(l.Fragment, {});
  var f = [];
  if (pt(a, r))
    for (var v = C(a), h = a.getMonth(); h <= r.getMonth(); h++)
      f.push(ee(v, h));
  else
    for (var v = C(/* @__PURE__ */ new Date()), h = 0; h <= 11; h++)
      f.push(ee(v, h));
  var p = function(w) {
    var D = Number(w.target.value), x = ee(C(e.displayMonth), D);
    e.onChange(x);
  }, g = (n = c?.Dropdown) !== null && n !== void 0 ? n : Le;
  return l.jsx(g, { name: "months", "aria-label": u(), className: d.dropdown_month, style: o.dropdown_month, onChange: p, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: i }), children: f.map(function(w) {
    return l.jsx("option", { value: w.getMonth(), children: s(w, { locale: i }) }, w.getMonth());
  }) });
}
function At(e) {
  var n, t = e.displayMonth, a = _(), r = a.fromDate, o = a.toDate, i = a.locale, s = a.styles, d = a.classNames, c = a.components, u = a.formatters.formatYearCaption, f = a.labels.labelYearDropdown, v = [];
  if (!r)
    return l.jsx(l.Fragment, {});
  if (!o)
    return l.jsx(l.Fragment, {});
  for (var h = r.getFullYear(), p = o.getFullYear(), g = h; g <= p; g++)
    v.push(De(at(/* @__PURE__ */ new Date()), g));
  var w = function(x) {
    var I = De(C(t), Number(x.target.value));
    e.onChange(I);
  }, D = (n = c?.Dropdown) !== null && n !== void 0 ? n : Le;
  return l.jsx(D, { name: "years", "aria-label": f(), className: d.dropdown_year, style: s.dropdown_year, onChange: w, value: t.getFullYear(), caption: u(t, { locale: i }), children: v.map(function(x) {
    return l.jsx("option", { value: x.getFullYear(), children: u(x, { locale: i }) }, x.getFullYear());
  }) });
}
function Ht(e, n) {
  var t = E(e), a = t[0], r = t[1], o = n === void 0 ? a : n;
  return [o, r];
}
function zt(e) {
  var n = e.month, t = e.defaultMonth, a = e.today, r = n || t || a || /* @__PURE__ */ new Date(), o = e.toDate, i = e.fromDate, s = e.numberOfMonths, d = s === void 0 ? 1 : s;
  if (o && B(o, r) < 0) {
    var c = -1 * (d - 1);
    r = j(o, c);
  }
  return i && B(r, i) < 0 && (r = i), C(r);
}
function Ut() {
  var e = _(), n = zt(e), t = Ht(n, e.month), a = t[0], r = t[1], o = function(i) {
    var s;
    if (!e.disableNavigation) {
      var d = C(i);
      r(d), (s = e.onMonthChange) === null || s === void 0 || s.call(e, d);
    }
  };
  return [a, o];
}
function Kt(e, n) {
  for (var t = n.reverseMonths, a = n.numberOfMonths, r = C(e), o = C(j(r, a)), i = B(o, r), s = [], d = 0; d < i; d++) {
    var c = j(r, d);
    s.push(c);
  }
  return t && (s = s.reverse()), s;
}
function Vt(e, n) {
  if (!n.disableNavigation) {
    var t = n.toDate, a = n.pagedNavigation, r = n.numberOfMonths, o = r === void 0 ? 1 : r, i = a ? o : 1, s = C(e);
    if (!t)
      return j(s, i);
    var d = B(t, e);
    if (!(d < o))
      return j(s, i);
  }
}
function Zt(e, n) {
  if (!n.disableNavigation) {
    var t = n.fromDate, a = n.pagedNavigation, r = n.numberOfMonths, o = r === void 0 ? 1 : r, i = a ? o : 1, s = C(e);
    if (!t)
      return j(s, -i);
    var d = B(s, t);
    if (!(d <= 0))
      return j(s, -i);
  }
}
var Ie = W(void 0);
function Gt(e) {
  var n = _(), t = Ut(), a = t[0], r = t[1], o = Kt(a, n), i = Vt(a, n), s = Zt(a, n), d = function(f) {
    return o.some(function(v) {
      return ce(f, v);
    });
  }, c = function(f, v) {
    d(f) || (v && Pe(f, v) ? r(j(f, 1 + n.numberOfMonths * -1)) : r(f));
  }, u = {
    currentMonth: a,
    displayMonths: o,
    goToMonth: r,
    goToDate: c,
    previousMonth: s,
    nextMonth: i,
    isDateDisplayed: d
  };
  return l.jsx(Ie.Provider, { value: u, children: e.children });
}
function z() {
  var e = F(Ie);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function Ne(e) {
  var n, t = _(), a = t.classNames, r = t.styles, o = t.components, i = z().goToMonth, s = function(u) {
    i(j(u, e.displayIndex ? -e.displayIndex : 0));
  }, d = (n = o?.CaptionLabel) !== null && n !== void 0 ? n : Fe, c = l.jsx(d, { id: e.id, displayMonth: e.displayMonth });
  return l.jsxs("div", { className: a.caption_dropdowns, style: r.caption_dropdowns, children: [l.jsx("div", { className: a.vhidden, children: c }), l.jsx(Bt, { onChange: s, displayMonth: e.displayMonth }), l.jsx(At, { onChange: s, displayMonth: e.displayMonth })] });
}
function qt(e) {
  return l.jsx("svg", y({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: l.jsx("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Xt(e) {
  return l.jsx("svg", y({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: l.jsx("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var K = Je(function(e, n) {
  var t = _(), a = t.classNames, r = t.styles, o = [a.button_reset, a.button];
  e.className && o.push(e.className);
  var i = o.join(" "), s = y(y({}, r.button_reset), r.button);
  return e.style && Object.assign(s, e.style), l.jsx("button", y({}, e, { ref: n, type: "button", className: i, style: s }));
});
function $_t(e) {
  var n, t, a = _(), r = a.dir, o = a.locale, i = a.classNames, s = a.styles, d = a.labels, c = d.labelPrevious, u = d.labelNext, f = a.components;
  if (!e.nextMonth && !e.previousMonth)
    return l.jsx(l.Fragment, {});
  var v = c(e.previousMonth, { locale: o }), h = [
    i.nav_button,
    i.nav_button_previous
  ].join(" "), p = u(e.nextMonth, { locale: o }), g = [
    i.nav_button,
    i.nav_button_next
  ].join(" "), w = (n = f?.IconRight) !== null && n !== void 0 ? n : Xt, D = (t = f?.IconLeft) !== null && t !== void 0 ? t : qt;
  return l.jsxs("div", { className: i.nav, style: s.nav, children: [!e.hidePrevious && l.jsx(K, { name: "previous-month", "aria-label": v, className: h, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: r === "rtl" ? l.jsx(w, { className: i.nav_icon, style: s.nav_icon }) : l.jsx(D, { className: i.nav_icon, style: s.nav_icon }) }), !e.hideNext && l.jsx(K, { name: "next-month", "aria-label": p, className: g, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: r === "rtl" ? l.jsx(D, { className: i.nav_icon, style: s.nav_icon }) : l.jsx(w, { className: i.nav_icon, style: s.nav_icon }) })] });
}
function Me(e) {
  var n = _().numberOfMonths, t = z(), a = t.previousMonth, r = t.nextMonth, o = t.goToMonth, i = t.displayMonths, s = i.findIndex(function(p) {
    return ce(e.displayMonth, p);
  }), d = s === 0, c = s === i.length - 1, u = n > 1 && (d || !c), f = n > 1 && (c || !d), v = function() {
    a && o(a);
  }, h = function() {
    r && o(r);
  };
  return l.jsx($_t, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: f, nextMonth: r, previousMonth: a, onPreviousClick: v, onNextClick: h });
}
function Jt(e) {
  var n, t = _(), a = t.classNames, r = t.disableNavigation, o = t.styles, i = t.captionLayout, s = t.components, d = (n = s?.CaptionLabel) !== null && n !== void 0 ? n : Fe, c;
  return r ? c = l.jsx(d, { id: e.id, displayMonth: e.displayMonth }) : i === "dropdown" ? c = l.jsx(Ne, { displayMonth: e.displayMonth, id: e.id }) : i === "dropdown-buttons" ? c = l.jsxs(l.Fragment, { children: [l.jsx(Ne, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), l.jsx(Me, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = l.jsxs(l.Fragment, { children: [l.jsx(d, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), l.jsx(Me, { displayMonth: e.displayMonth, id: e.id })] }), l.jsx("div", { className: a.caption, style: o.caption, children: c });
}
function Qt(e) {
  var n = _(), t = n.footer, a = n.styles, r = n.classNames.tfoot;
  return t ? l.jsx("tfoot", { className: r, style: a.tfoot, children: l.jsx("tr", { children: l.jsx("td", { colSpan: 8, children: t }) }) }) : l.jsx(l.Fragment, {});
}
function en(e, n, t) {
  for (var a = t ? le(/* @__PURE__ */ new Date()) : Y(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: n }), r = [], o = 0; o < 7; o++) {
    var i = M(a, o);
    r.push(i);
  }
  return r;
}
function tn() {
  var e = _(), n = e.classNames, t = e.styles, a = e.showWeekNumber, r = e.locale, o = e.weekStartsOn, i = e.ISOWeek, s = e.formatters.formatWeekdayName, d = e.labels.labelWeekday, c = en(r, o, i);
  return l.jsxs("tr", { style: t.head_row, className: n.head_row, children: [a && l.jsx("td", { style: t.head_cell, className: n.head_cell }), c.map(function(u, f) {
    return l.jsx("th", { scope: "col", className: n.head_cell, style: t.head_cell, "aria-label": d(u, { locale: r }), children: s(u, { locale: r }) }, f);
  })] });
}
function nn() {
  var e, n = _(), t = n.classNames, a = n.styles, r = n.components, o = (e = r?.HeadRow) !== null && e !== void 0 ? e : tn;
  return l.jsx("thead", { style: a.head, className: t.head, children: l.jsx(o, {}) });
}
function an(e) {
  var n = _(), t = n.locale, a = n.formatters.formatDay;
  return l.jsx(l.Fragment, { children: a(e.date, { locale: t }) });
}
var fe = W(void 0);
function rn(e) {
  if (!A(e.initialProps)) {
    var n = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return l.jsx(fe.Provider, { value: n, children: e.children });
  }
  return l.jsx(on, { initialProps: e.initialProps, children: e.children });
}
function on(e) {
  var n = e.initialProps, t = e.children, a = n.selected, r = n.min, o = n.max, i = function(c, u, f) {
    var v, h;
    (v = n.onDayClick) === null || v === void 0 || v.call(n, c, u, f);
    var p = !!(u.selected && r && a?.length === r);
    if (!p) {
      var g = !!(!u.selected && o && a?.length === o);
      if (!g) {
        var w = a ? Se([], a) : [];
        if (u.selected) {
          var D = w.findIndex(function(x) {
            return k(c, x);
          });
          w.splice(D, 1);
        } else
          w.push(c);
        (h = n.onSelect) === null || h === void 0 || h.call(n, w, c, u, f);
      }
    }
  }, s = {
    disabled: []
  };
  a && s.disabled.push(function(c) {
    var u = o && a.length > o - 1, f = a.some(function(v) {
      return k(v, c);
    });
    return !!(u && !f);
  });
  var d = {
    selected: a,
    onDayClick: i,
    modifiers: s
  };
  return l.jsx(fe.Provider, { value: d, children: t });
}
function ve() {
  var e = F(fe);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function sn(e, n) {
  var t = n || {}, a = t.from, r = t.to;
  return a && r ? k(r, e) && k(a, e) ? void 0 : k(r, e) ? { from: r, to: void 0 } : k(a, e) ? void 0 : ie(a, e) ? { from: e, to: r } : { from: a, to: e } : r ? ie(e, r) ? { from: r, to: e } : { from: e, to: r } : a ? Pe(e, a) ? { from: e, to: a } : { from: a, to: e } : { from: e, to: void 0 };
}
var me = W(void 0);
function ln(e) {
  if (!H(e.initialProps)) {
    var n = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return l.jsx(me.Provider, { value: n, children: e.children });
  }
  return l.jsx(dn, { initialProps: e.initialProps, children: e.children });
}
function dn(e) {
  var n = e.initialProps, t = e.children, a = n.selected, r = a || {}, o = r.from, i = r.to, s = n.min, d = n.max, c = function(h, p, g) {
    var w, D;
    (w = n.onDayClick) === null || w === void 0 || w.call(n, h, p, g);
    var x = sn(h, a);
    (D = n.onSelect) === null || D === void 0 || D.call(n, x, h, p, g);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (o ? (u.range_start = [o], i ? (u.range_end = [i], k(o, i) || (u.range_middle = [
    {
      after: o,
      before: i
    }
  ])) : u.range_end = [o]) : i && (u.range_start = [i], u.range_end = [i]), s && (o && !i && u.disabled.push({
    after: Q(o, s - 1),
    before: M(o, s - 1)
  }), o && i && u.disabled.push({
    after: o,
    before: M(o, s - 1)
  }), !o && i && u.disabled.push({
    after: Q(i, s - 1),
    before: M(i, s - 1)
  })), d) {
    if (o && !i && (u.disabled.push({
      before: M(o, -d + 1)
    }), u.disabled.push({
      after: M(o, d - 1)
    })), o && i) {
      var f = S(i, o) + 1, v = d - f;
      u.disabled.push({
        before: Q(o, v)
      }), u.disabled.push({
        after: M(i, v)
      });
    }
    !o && i && (u.disabled.push({
      before: M(i, -d + 1)
    }), u.disabled.push({
      after: M(i, d - 1)
    }));
  }
  return l.jsx(me.Provider, { value: { selected: a, onDayClick: c, modifiers: u }, children: t });
}
function he() {
  var e = F(me);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function U(e) {
  return Array.isArray(e) ? Se([], e) : e !== void 0 ? [e] : [];
}
function un(e) {
  var n = {};
  return Object.entries(e).forEach(function(t) {
    var a = t[0], r = t[1];
    n[a] = U(r);
  }), n;
}
var O;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(O || (O = {}));
var cn = O.Selected, P = O.Disabled, fn = O.Hidden, vn = O.Today, te = O.RangeEnd, ne = O.RangeMiddle, ae = O.RangeStart, mn = O.Outside;
function hn(e, n, t) {
  var a, r = (a = {}, a[cn] = U(e.selected), a[P] = U(e.disabled), a[fn] = U(e.hidden), a[vn] = [e.today], a[te] = [], a[ne] = [], a[ae] = [], a[mn] = [], a);
  return e.fromDate && r[P].push({ before: e.fromDate }), e.toDate && r[P].push({ after: e.toDate }), A(e) ? r[P] = r[P].concat(n.modifiers[P]) : H(e) && (r[P] = r[P].concat(t.modifiers[P]), r[ae] = t.modifiers[ae], r[ne] = t.modifiers[ne], r[te] = t.modifiers[te]), r;
}
var Re = W(void 0);
function yn(e) {
  var n = _(), t = ve(), a = he(), r = hn(n, t, a), o = un(n.modifiers), i = y(y({}, r), o);
  return l.jsx(Re.Provider, { value: i, children: e.children });
}
function Te() {
  var e = F(Re);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function bn(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function pn(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function wn(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function gn(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function _n(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function xn(e, n) {
  var t, a = n.from, r = n.to;
  if (a && r) {
    var o = S(r, a) < 0;
    o && (t = [r, a], a = t[0], r = t[1]);
    var i = S(e, a) >= 0 && S(r, e) >= 0;
    return i;
  }
  return r ? k(r, e) : a ? k(a, e) : !1;
}
function Dn(e) {
  return je(e);
}
function Nn(e) {
  return Array.isArray(e) && e.every(je);
}
function Mn(e, n) {
  return n.some(function(t) {
    if (typeof t == "boolean")
      return t;
    if (Dn(t))
      return k(e, t);
    if (Nn(t))
      return t.includes(e);
    if (pn(t))
      return xn(e, t);
    if (_n(t))
      return t.dayOfWeek.includes(e.getDay());
    if (bn(t)) {
      var a = S(t.before, e), r = S(t.after, e), o = a > 0, i = r < 0, s = ie(t.before, t.after);
      return s ? i && o : o || i;
    }
    return wn(t) ? S(e, t.after) > 0 : gn(t) ? S(t.before, e) > 0 : typeof t == "function" ? t(e) : !1;
  });
}
function ye(e, n, t) {
  var a = Object.keys(n).reduce(function(o, i) {
    var s = n[i];
    return Mn(e, s) && o.push(i), o;
  }, []), r = {};
  return a.forEach(function(o) {
    return r[o] = !0;
  }), t && !ce(e, t) && (r.outside = !0), r;
}
function kn(e, n) {
  for (var t = C(e[0]), a = de(e[e.length - 1]), r, o, i = t; i <= a; ) {
    var s = ye(i, n), d = !s.disabled && !s.hidden;
    if (!d) {
      i = M(i, 1);
      continue;
    }
    if (s.selected)
      return i;
    s.today && !o && (o = i), r || (r = i), i = M(i, 1);
  }
  return o || r;
}
var Cn = 365;
function Ee(e, n) {
  var t = n.moveBy, a = n.direction, r = n.context, o = n.modifiers, i = n.retry, s = i === void 0 ? { count: 0, lastFocused: e } : i, d = r.weekStartsOn, c = r.fromDate, u = r.toDate, f = r.locale, v = {
    day: M,
    week: se,
    month: j,
    year: ct,
    startOfWeek: function(w) {
      return r.ISOWeek ? le(w) : Y(w, { locale: f, weekStartsOn: d });
    },
    endOfWeek: function(w) {
      return r.ISOWeek ? Oe(w) : ue(w, { locale: f, weekStartsOn: d });
    }
  }, h = v[t](e, a === "after" ? 1 : -1);
  a === "before" && c ? h = ft([c, h]) : a === "after" && u && (h = vt([u, h]));
  var p = !0;
  if (o) {
    var g = ye(h, o);
    p = !g.disabled && !g.hidden;
  }
  return p ? h : s.count > Cn ? s.lastFocused : Ee(h, {
    moveBy: t,
    direction: a,
    context: r,
    modifiers: o,
    retry: y(y({}, s), { count: s.count + 1 })
  });
}
var Ye = W(void 0);
function jn(e) {
  var n = z(), t = Te(), a = E(), r = a[0], o = a[1], i = E(), s = i[0], d = i[1], c = kn(n.displayMonths, t), u = r ?? (s && n.isDateDisplayed(s)) ? s : c, f = function() {
    d(r), o(void 0);
  }, v = function(w) {
    o(w);
  }, h = _(), p = function(w, D) {
    if (r) {
      var x = Ee(r, {
        moveBy: w,
        direction: D,
        context: h,
        modifiers: t
      });
      k(r, x) || (n.goToDate(x, r), v(x));
    }
  }, g = {
    focusedDay: r,
    focusTarget: u,
    blur: f,
    focus: v,
    focusDayAfter: function() {
      return p("day", "after");
    },
    focusDayBefore: function() {
      return p("day", "before");
    },
    focusWeekAfter: function() {
      return p("week", "after");
    },
    focusWeekBefore: function() {
      return p("week", "before");
    },
    focusMonthBefore: function() {
      return p("month", "before");
    },
    focusMonthAfter: function() {
      return p("month", "after");
    },
    focusYearBefore: function() {
      return p("year", "before");
    },
    focusYearAfter: function() {
      return p("year", "after");
    },
    focusStartOfWeek: function() {
      return p("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return p("endOfWeek", "after");
    }
  };
  return l.jsx(Ye.Provider, { value: g, children: e.children });
}
function be() {
  var e = F(Ye);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function On(e, n) {
  var t = Te(), a = ye(e, t, n);
  return a;
}
var pe = W(void 0);
function Pn(e) {
  if (!Z(e.initialProps)) {
    var n = {
      selected: void 0
    };
    return l.jsx(pe.Provider, { value: n, children: e.children });
  }
  return l.jsx(Sn, { initialProps: e.initialProps, children: e.children });
}
function Sn(e) {
  var n = e.initialProps, t = e.children, a = function(o, i, s) {
    var d, c, u;
    if ((d = n.onDayClick) === null || d === void 0 || d.call(n, o, i, s), i.selected && !n.required) {
      (c = n.onSelect) === null || c === void 0 || c.call(n, void 0, o, i, s);
      return;
    }
    (u = n.onSelect) === null || u === void 0 || u.call(n, o, o, i, s);
  }, r = {
    selected: n.selected,
    onDayClick: a
  };
  return l.jsx(pe.Provider, { value: r, children: t });
}
function Be() {
  var e = F(pe);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function Wn(e, n) {
  var t = _(), a = Be(), r = ve(), o = he(), i = be(), s = i.focusDayAfter, d = i.focusDayBefore, c = i.focusWeekAfter, u = i.focusWeekBefore, f = i.blur, v = i.focus, h = i.focusMonthBefore, p = i.focusMonthAfter, g = i.focusYearBefore, w = i.focusYearAfter, D = i.focusStartOfWeek, x = i.focusEndOfWeek, I = function(b) {
    var m, X, $, J;
    Z(t) ? (m = a.onDayClick) === null || m === void 0 || m.call(a, e, n, b) : A(t) ? (X = r.onDayClick) === null || X === void 0 || X.call(r, e, n, b) : H(t) ? ($ = o.onDayClick) === null || $ === void 0 || $.call(o, e, n, b) : (J = t.onDayClick) === null || J === void 0 || J.call(t, e, n, b);
  }, G = function(b) {
    var m;
    v(e), (m = t.onDayFocus) === null || m === void 0 || m.call(t, e, n, b);
  }, q = function(b) {
    var m;
    f(), (m = t.onDayBlur) === null || m === void 0 || m.call(t, e, n, b);
  }, R = function(b) {
    var m;
    (m = t.onDayMouseEnter) === null || m === void 0 || m.call(t, e, n, b);
  }, Ae = function(b) {
    var m;
    (m = t.onDayMouseLeave) === null || m === void 0 || m.call(t, e, n, b);
  }, He = function(b) {
    var m;
    (m = t.onDayPointerEnter) === null || m === void 0 || m.call(t, e, n, b);
  }, ze = function(b) {
    var m;
    (m = t.onDayPointerLeave) === null || m === void 0 || m.call(t, e, n, b);
  }, Ue = function(b) {
    var m;
    (m = t.onDayTouchCancel) === null || m === void 0 || m.call(t, e, n, b);
  }, Ke = function(b) {
    var m;
    (m = t.onDayTouchEnd) === null || m === void 0 || m.call(t, e, n, b);
  }, Ve = function(b) {
    var m;
    (m = t.onDayTouchMove) === null || m === void 0 || m.call(t, e, n, b);
  }, Ze = function(b) {
    var m;
    (m = t.onDayTouchStart) === null || m === void 0 || m.call(t, e, n, b);
  }, Ge = function(b) {
    var m;
    (m = t.onDayKeyUp) === null || m === void 0 || m.call(t, e, n, b);
  }, qe = function(b) {
    var m;
    switch (b.key) {
      case "ArrowLeft":
        b.preventDefault(), b.stopPropagation(), t.dir === "rtl" ? s() : d();
        break;
      case "ArrowRight":
        b.preventDefault(), b.stopPropagation(), t.dir === "rtl" ? d() : s();
        break;
      case "ArrowDown":
        b.preventDefault(), b.stopPropagation(), c();
        break;
      case "ArrowUp":
        b.preventDefault(), b.stopPropagation(), u();
        break;
      case "PageUp":
        b.preventDefault(), b.stopPropagation(), b.shiftKey ? g() : h();
        break;
      case "PageDown":
        b.preventDefault(), b.stopPropagation(), b.shiftKey ? w() : p();
        break;
      case "Home":
        b.preventDefault(), b.stopPropagation(), D();
        break;
      case "End":
        b.preventDefault(), b.stopPropagation(), x();
        break;
    }
    (m = t.onDayKeyDown) === null || m === void 0 || m.call(t, e, n, b);
  }, Xe = {
    onClick: I,
    onFocus: G,
    onBlur: q,
    onKeyDown: qe,
    onKeyUp: Ge,
    onMouseEnter: R,
    onMouseLeave: Ae,
    onPointerEnter: He,
    onPointerLeave: ze,
    onTouchCancel: Ue,
    onTouchEnd: Ke,
    onTouchMove: Ve,
    onTouchStart: Ze
  };
  return Xe;
}
function Fn() {
  var e = _(), n = Be(), t = ve(), a = he(), r = Z(e) ? n.selected : A(e) ? t.selected : H(e) ? a.selected : void 0;
  return r;
}
function Ln(e) {
  return Object.values(O).includes(e);
}
function In(e, n) {
  var t = [e.classNames.day];
  return Object.keys(n).forEach(function(a) {
    var r = e.modifiersClassNames[a];
    if (r)
      t.push(r);
    else if (Ln(a)) {
      var o = e.classNames["day_".concat(a)];
      o && t.push(o);
    }
  }), t;
}
function Rn(e, n) {
  var t = y({}, e.styles.day);
  return Object.keys(n).forEach(function(a) {
    var r;
    t = y(y({}, t), (r = e.modifiersStyles) === null || r === void 0 ? void 0 : r[a]);
  }), t;
}
function Tn(e, n, t) {
  var a, r, o, i = _(), s = be(), d = On(e, n), c = Wn(e, d), u = Fn(), f = !!(i.onDayClick || i.mode !== "default");
  V(function() {
    var R;
    d.outside || s.focusedDay && f && k(s.focusedDay, e) && ((R = t.current) === null || R === void 0 || R.focus());
  }, [
    s.focusedDay,
    e,
    t,
    f,
    d.outside
  ]);
  var v = In(i, d).join(" "), h = Rn(i, d), p = !!(d.outside && !i.showOutsideDays || d.hidden), g = (o = (r = i.components) === null || r === void 0 ? void 0 : r.DayContent) !== null && o !== void 0 ? o : an, w = l.jsx(g, { date: e, displayMonth: n, activeModifiers: d }), D = {
    style: h,
    className: v,
    children: w,
    role: "gridcell"
  }, x = s.focusTarget && k(s.focusTarget, e) && !d.outside, I = s.focusedDay && k(s.focusedDay, e), G = y(y(y({}, D), (a = { disabled: d.disabled, role: "gridcell" }, a["aria-selected"] = d.selected, a.tabIndex = I || x ? 0 : -1, a)), c), q = {
    isButton: f,
    isHidden: p,
    activeModifiers: d,
    selectedDays: u,
    buttonProps: G,
    divProps: D
  };
  return q;
}
function En(e) {
  var n = Qe(null), t = Tn(e.date, e.displayMonth, n);
  return t.isHidden ? l.jsx("div", { role: "gridcell" }) : t.isButton ? l.jsx(K, y({ name: "day", ref: n }, t.buttonProps)) : l.jsx("div", y({}, t.divProps));
}
function Yn(e) {
  var n = e.number, t = e.dates, a = _(), r = a.onWeekNumberClick, o = a.styles, i = a.classNames, s = a.locale, d = a.labels.labelWeekNumber, c = a.formatters.formatWeekNumber, u = c(Number(n), { locale: s });
  if (!r)
    return l.jsx("span", { className: i.weeknumber, style: o.weeknumber, children: u });
  var f = d(Number(n), { locale: s }), v = function(h) {
    r(n, t, h);
  };
  return l.jsx(K, { name: "week-number", "aria-label": f, className: i.weeknumber, style: o.weeknumber, onClick: v, children: u });
}
function Bn(e) {
  var n, t, a = _(), r = a.styles, o = a.classNames, i = a.showWeekNumber, s = a.components, d = (n = s?.Day) !== null && n !== void 0 ? n : En, c = (t = s?.WeekNumber) !== null && t !== void 0 ? t : Yn, u;
  return i && (u = l.jsx("td", { className: o.cell, style: r.cell, children: l.jsx(c, { number: e.weekNumber, dates: e.dates }) })), l.jsxs("tr", { className: o.row, style: r.row, children: [u, e.dates.map(function(f) {
    return l.jsx("td", { className: o.cell, style: r.cell, role: "presentation", children: l.jsx(d, { displayMonth: e.displayMonth, date: f }) }, ht(f));
  })] });
}
function ke(e, n, t) {
  for (var a = t?.ISOWeek ? Oe(n) : ue(n, t), r = t?.ISOWeek ? le(e) : Y(e, t), o = S(a, r), i = [], s = 0; s <= o; s++)
    i.push(M(r, s));
  var d = i.reduce(function(c, u) {
    var f = t?.ISOWeek ? rt(u) : ot(u, t), v = c.find(function(h) {
      return h.weekNumber === f;
    });
    return v ? (v.dates.push(u), c) : (c.push({
      weekNumber: f,
      dates: [u]
    }), c);
  }, []);
  return d;
}
function An(e, n) {
  var t = ke(C(e), de(e), n);
  if (n?.useFixedWeeks) {
    var a = bt(e, n);
    if (a < 6) {
      var r = t[t.length - 1], o = r.dates[r.dates.length - 1], i = se(o, 6 - a), s = ke(se(o, 1), i, n);
      t.push.apply(t, s);
    }
  }
  return t;
}
function Hn(e) {
  var n, t, a, r = _(), o = r.locale, i = r.classNames, s = r.styles, d = r.hideHead, c = r.fixedWeeks, u = r.components, f = r.weekStartsOn, v = r.firstWeekContainsDate, h = r.ISOWeek, p = An(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: h,
    locale: o,
    weekStartsOn: f,
    firstWeekContainsDate: v
  }), g = (n = u?.Head) !== null && n !== void 0 ? n : nn, w = (t = u?.Row) !== null && t !== void 0 ? t : Bn, D = (a = u?.Footer) !== null && a !== void 0 ? a : Qt;
  return l.jsxs("table", { id: e.id, className: i.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!d && l.jsx(g, {}), l.jsx("tbody", { className: i.tbody, style: s.tbody, children: p.map(function(x) {
    return l.jsx(w, { displayMonth: e.displayMonth, dates: x.dates, weekNumber: x.weekNumber }, x.weekNumber);
  }) }), l.jsx(D, { displayMonth: e.displayMonth })] });
}
function zn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Un = zn() ? $e : V, re = !1, Kn = 0;
function Ce() {
  return "react-day-picker-".concat(++Kn);
}
function Vn(e) {
  var n, t = e ?? (re ? Ce() : null), a = E(t), r = a[0], o = a[1];
  return Un(function() {
    r === null && o(Ce());
  }, []), V(function() {
    re === !1 && (re = !0);
  }, []), (n = e ?? r) !== null && n !== void 0 ? n : void 0;
}
function Zn(e) {
  var n, t, a = _(), r = a.dir, o = a.classNames, i = a.styles, s = a.components, d = z().displayMonths, c = Vn(a.id ? "".concat(a.id, "-").concat(e.displayIndex) : void 0), u = a.id ? "".concat(a.id, "-grid-").concat(e.displayIndex) : void 0, f = [o.month], v = i.month, h = e.displayIndex === 0, p = e.displayIndex === d.length - 1, g = !h && !p;
  r === "rtl" && (n = [h, p], p = n[0], h = n[1]), h && (f.push(o.caption_start), v = y(y({}, v), i.caption_start)), p && (f.push(o.caption_end), v = y(y({}, v), i.caption_end)), g && (f.push(o.caption_between), v = y(y({}, v), i.caption_between));
  var w = (t = s?.Caption) !== null && t !== void 0 ? t : Jt;
  return l.jsxs("div", { className: f.join(" "), style: v, children: [l.jsx(w, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), l.jsx(Hn, { id: u, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function Gn(e) {
  var n = _(), t = n.classNames, a = n.styles;
  return l.jsx("div", { className: t.months, style: a.months, children: e.children });
}
function qn(e) {
  var n, t, a = e.initialProps, r = _(), o = be(), i = z(), s = E(!1), d = s[0], c = s[1];
  V(function() {
    r.initialFocus && o.focusTarget && (d || (o.focus(o.focusTarget), c(!0)));
  }, [
    r.initialFocus,
    d,
    o.focus,
    o.focusTarget,
    o
  ]);
  var u = [r.classNames.root, r.className];
  r.numberOfMonths > 1 && u.push(r.classNames.multiple_months), r.showWeekNumber && u.push(r.classNames.with_weeknumber);
  var f = y(y({}, r.styles.root), r.style), v = Object.keys(a).filter(function(p) {
    return p.startsWith("data-");
  }).reduce(function(p, g) {
    var w;
    return y(y({}, p), (w = {}, w[g] = a[g], w));
  }, {}), h = (t = (n = a.components) === null || n === void 0 ? void 0 : n.Months) !== null && t !== void 0 ? t : Gn;
  return l.jsx("div", y({ className: u.join(" "), style: f, dir: r.dir, id: r.id, nonce: a.nonce, title: a.title, lang: a.lang }, v, { children: l.jsx(h, { children: i.displayMonths.map(function(p, g) {
    return l.jsx(Zn, { displayIndex: g, displayMonth: p }, g);
  }) }) }));
}
function Xn(e) {
  var n = e.children, t = wt(e, ["children"]);
  return l.jsx(Et, { initialProps: t, children: l.jsx(Gt, { children: l.jsx(Pn, { initialProps: t, children: l.jsx(rn, { initialProps: t, children: l.jsx(ln, { initialProps: t, children: l.jsx(yn, { children: l.jsx(jn, { children: n }) }) }) }) }) }) });
}
function $n(e) {
  return l.jsx(Xn, y({}, e, { children: l.jsx(qn, { initialProps: e }) }));
}
const Jn = () => {
  const e = document.getElementsByClassName("calendar-body");
  return Array.from(e || []).map((n) => dt(/* @__PURE__ */ l.jsx("tr", { className: "tw-bg-base-white tw-flex tw-items-center tw-justify-center tw-inset-0 tw-absolute tw-bg-opacity-90 tw-z-50", children: /* @__PURE__ */ l.jsx("td", { children: /* @__PURE__ */ l.jsx(ut, { appearance: "black", size: "large" }) }) }), n));
}, Qn = ({
  className: e,
  classNames: n,
  showOutsideDays: t = !1,
  showLoading: a = !1,
  fullWidth: r = !1,
  footer: o,
  components: i,
  modifiersClassNames: s,
  locale: d = "en-US",
  mode: c,
  ...u
}) => {
  const [f, v] = we.useState(!1);
  return we.useEffect(() => {
    v(!0);
  }, []), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      $n,
      {
        showOutsideDays: t,
        className: T("!tw-m-0 tw-rounded-4 tw-bg-base-white calendar-container tw-shadow-xs tw-relative", {
          "tw-w-full": r
        }, e),
        classNames: {
          months: "tw-flex tw-flex-col sm:tw-flex-row tw-flex-wrap",
          month: T("tw-space-y-16 tw-w-full tw-p-16 tw-flex-1 tw-relative [&.rdp-caption_end]:!tw-hidden", {
            "tw-min-w-[280px] tw-max-w-[352px]": !r,
            "tw-pb-0": !!o
          }),
          caption: "tw-flex tw-justify-between tw-relative tw-items-center",
          caption_label: "tw-w-full tw-text-center tw-body-2-m",
          nav: "tw-flex tw-items-center tw-justify-between tw-gap-8 tw-absolute tw-inset-0 calendar-nav [&:has(.next-month-icon):not(:has(.prev-month-icon))]:tw-justify-end",
          nav_button: T(xe({
            variant: "ghost"
          }), "tw-size-28 tw-bg-transparent tw-p-0"),
          table: T("tw-w-full tw-border-collapse tw-relative tw-space-y-4"),
          head_row: "tw-flex",
          head_cell: "tw-w-full tw-caption-2 tw-text-gray-600 tw-text-center",
          row: "tw-flex tw-w-full tw-mt-4",
          cell: "tw-h-32 tw-w-full tw-text-center tw-p-0 tw-relative focus-within:tw-relative focus-within:tw-z-20 [&:has([aria-selected].day-range-end)]:tw-bg-gray-300 [&:has([aria-selected].day-range-start)]:tw-bg-gray-300 [&:has([aria-selected].day-range-middle)]:tw-bg-gray-300 [&:has([aria-selected].day-range-start.day-range-end)]:tw-bg-transparent [&:has([aria-selected].day-range-start)]:tw-rounded-l-4 [&:has([aria-selected].day-range-end)]:tw-rounded-r-4 first:[&:has([aria-selected])]:tw-rounded-l-4 last:[&:has([aria-selected])]:tw-rounded-r-4",
          day: T(xe({
            variant: "ghost"
          }), "tw-size-32 tw-p-0 tw-body-1 aria-selected:tw-opacity-100 [&.day-outside]:tw-text-gray-600 [&.tw-day-today]:tw-text-purple-800 [&.day-selected]:!tw-text-base-white [&.day-selected]:tw-bg-gray-900 tw-rounded-4 disabled:!tw-text-gray-500 disabled:tw-pointer-events-none disabled:tw-line-through disabled:[&.day-selected]:!tw-text-base-white [&.day-range-middle.day-selected]:!tw-bg-transparent [&.day-range-middle.day-selected]:!tw-text-gray-900 [&.day-range-middle.tw-day-today]:!tw-text-purple-800"),
          day_range_start: "day-range-start",
          day_range_end: "day-range-end",
          day_selected: "day-selected",
          day_today: "tw-day-today",
          day_outside: "day-outside",
          day_range_middle: "day-range-middle",
          day_hidden: "tw-invisible",
          tbody: "tw-block tw-relative calendar-body",
          ...n
        },
        modifiersClassNames: {
          fullyBooked: "tw-pointer-events-none",
          ...s || {}
        },
        mode: c,
        components: {
          IconLeft: () => /* @__PURE__ */ l.jsx(it, { className: "prev-month-icon" }),
          IconRight: () => /* @__PURE__ */ l.jsx(st, { className: "next-month-icon" }),
          ...i || {}
        },
        locale: lt(d),
        ...u
      }
    ),
    f && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      a && /* @__PURE__ */ l.jsx(Jn, {}),
      o
    ] })
  ] });
};
Qn.displayName = "Calendar";
export {
  Qn as C,
  j as a,
  de as e,
  Pe as i,
  C as s
};
//# sourceMappingURL=Calendar.8LtDUeu3.js.map
